import { useState } from 'react';

// An inline confirmation replaces its trigger, which would drop keyboard focus to the document body.
// The caller puts `autoFocus` on the safe (cancel) control and `autoFocus={returned}` on the trigger.
export function useInlineConfirm(): { open: boolean; returned: boolean; ask: () => void; cancel: () => void } {
  const [state, setState] = useState<'idle' | 'open' | 'returned'>('idle');
  return { open: state === 'open', returned: state === 'returned', ask: () => setState('open'), cancel: () => setState('returned') };
}
